import type { ReactNode } from 'react'

import type { ResourceStatus } from '@/shared/lib/status'

import { SectionHeader, type SectionHeaderProps } from './SectionHeader'

/* Seção de listagem — substitui `PrizeSection`, `QuizSection`, `MissionSection`
   e `ScheduleSectionHeader`, que eram quatro implementações da mesma coisa com
   espaçamentos e cores diferentes. Ver `design.md §5.2`.

   O ritmo vertical ENTRE seções é do container que compõe as `ListSection`
   (`flex flex-col gap-5`), nunca `mb-*` aqui dentro — MASTER §7 L4. As quatro
   substituídas todas usavam `mb-5`, que somava com o gap do pai. */

export type ListSectionProps = {
  /** Liga a lista ao heading via `aria-labelledby`. */
  id: string
  title: string
  icon?: ReactNode
  count?: number
  /** Status da seção (visão "Todas") — colore o contador. Ver `SectionHeaderProps.status`. */
  status?: ResourceStatus
  as?: SectionHeaderProps['as']
  children: ReactNode
}

export const ListSection = ({
  id,
  title,
  icon,
  count,
  status,
  as,
  children
}: ListSectionProps) => (
  /* O `id` vai no heading emitido pelo `SectionHeader`, não no `<section>` —
     `aria-labelledby` precisa apontar para o texto, não para o container. */
  <section aria-labelledby={id} className="flex flex-col gap-2.5">
    <SectionHeader
      as={as}
      id={id}
      title={title}
      icon={icon}
      count={count}
      status={status}
    />
    <div className="flex flex-col gap-3">{children}</div>
  </section>
)

ListSection.displayName = 'ListSection'
